export default "__VITE_ASSET__C16Ujfzi__"